import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate} from "react-router-dom";
import PageTitle from "../components/PageTitle";
import PageWrapper from "../layouts/Index";
import {getCustomersInProgress } from "../services/PrequalificationService";
import useCustomAlert from "../components/Alert2";
import Alerts from "../components/Alerts";
import { Box } from "@mui/material";
import Loader2 from "../utils/Loader2";
import { getFinancier, getPreCustomerByMsisdn } from "../redux/features/oxygen/oxygenRetailSlice";
import { handleContinueOnboarding } from "../components/CustomerRedirect";
import { setShowModal } from "../redux/features/oxygen/customModalSlice";

const InProgressCustomers = () => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state?.user?.user?.id);
  const [customersInProgress, setCustomersInProgress] = useState([]);
  const customAlert = useCustomAlert();
  const [msg, setMsg] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoadingId, setIsLoadingId] = useState(null);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const allPartners = useSelector((state) => state.oxygenRetail?.financiers)

  useEffect(()=>{
    dispatch(getFinancier());
  }, [dispatch]);

  // To handle navigation to the particular onboarding phase
  const handleContinueOnboardingProcess = async(item) => {
    setIsLoadingId(item?.id);
    const res = await dispatch(getPreCustomerByMsisdn(item?.msisdn));
    
    if(res.status === true || res?.payload.status === true) {
      const data = res?.payload?.data || res?.data;
      const partnerId = res?.partnerId || res?.payload?.partnerId;
      const bankFinacier = allPartners?.filter((partner) => Number(partner?.partnerId) === Number(partnerId)) || [];
      localStorage.setItem("allAboard-partnerid", JSON.stringify(bankFinacier[0]?.partnerId || ""));
      localStorage.setItem("allAboard-financierid", JSON.stringify(bankFinacier[0]?.id || ""));
      localStorage.setItem("financierName", JSON.stringify(bankFinacier[0]?.name || ""));
      const isOxygenCustomer = bankFinacier[0]?.id === 14 ? "oxygen" : bankFinacier[0]?.id === 13 ? "FBN" : bankFinacier[0]?.id === 20 ? "AODF2" : "";

      setIsLoadingId(null);
      if(data && data?.onboardingStatus) {
        if (data?.onboardingStatus === "NEWENTRY" ){ 
          navigate("/dashboard")
        }
        handleContinueOnboarding(data, dispatch, navigate, isOxygenCustomer);
      }
    }else{
      setIsLoadingId(null);
      customAlert.showToast("error", `${res?.message || res?.payload?.message}`||  "Failed to get PreCustomer Details");
    }
    
  };

  // To handle change in the search input
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // Fetch all customers in progress immediately the page mounts
  useEffect(() => {
    async function fetchData(id) {
      try {
        // Empty message state
        setMsg("");

        // Set loader
        setLoading(true);

        // Fetch customer details
        const res = await getCustomersInProgress(id);


        if (res?.status === true) {
          // Set the state
          setCustomersInProgress(res?.data);

          // Set loader
          setLoading(false);
        } else {
          customAlert?.showToast(
            "error",
            res?.message || "Internal Server Error!"
          );
          // Set loader
          setLoading(false);
          setMsgType("danger");
          setMsg("Internal Server Error!");
        }
      } catch (error) {
        // Handle errors here, e.g., logging or displaying an error message.
        console.error("An error occurred:", error);
        customAlert?.showToast(
          "error",
          "An error occurred while fetching data."
        );
        setMsgType("danger");
        setMsg("An error occurred while fetching data.");
      }
    }

    // Invoke the async function immediately
    fetchData(userId);
  }, []);

  const handleClearPrecustomer = (item) => {
      dispatch(setShowModal({
        status:true,
        title:"Clear Precustomer's Details",
        type:"clearprecustomerDetails",
        showCloseButton:false,
        data:{item},
      }));
    }


  return (
    <PageWrapper>
      <div className="mt-4">
        {/* Alert - starts  */}
        {msg && (
          <Alerts
            alertType={msgType}
            title={
              msgType === "danger"
                ? "Oooopppsss, An error occurred...!!!"
                : "Successful...!!!"
            }
            message={msg}
          />
        )}
      </div>
      <PageTitle title="Onboarding - In Progress" />
      <div className="row overflow-scroll">
        <div className="col-sm-12 col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="list-group">
                {loading ? (
                  <Box
                    sx={{
                      height: "50px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Box>
                      <Loader2
                        height={"30px"}
                        width={"30px"}
                        margin="0 0 0 40%"
                      />
                      <p>Fetching customers...</p>
                    </Box>
                  </Box>
                ) : customersInProgress?.length > 0 ? (
                  customersInProgress.map((item, index) => (
                    <div className="card" key={index}>
                      <div
                        className="list-group-item flex-column align-items-start"
                        style={{ width: "<?php echo $pri_btn_width" }}
                      >
                        <div className="d-flex flex-column flex-md-row w-100 justify-content-between align-items-start">
                          <div>
                            <h5 className="text-muted">
                              {item?.fname} {item?.lname}{" "}
                              <strong>({item?.msisdn})</strong>
                            </h5>
                            <p class="text-muted">Precustomer ID: {item?.id}</p>
                            <p class="text-muted">
                              Credit Score: {item?.score}
                            </p>
                          </div>
                            <div className="align-self-end">
                              <div className="mb-1">
                                <small
                                  className={`text-secondary pb-2 d-flex justify-content-end`}
                                >
                                  {item?.onboardingStatus?.toLowerCase()}
                                </small>
                              </div>

                              <div>
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => handleContinueOnboardingProcess(item)}
                                >
                                  {isLoadingId === item?.id ? "Processing..." : "Continue Onboarding"}
                                </button>
                              </div>
                              <div className="mt-4"> 
                                <button type="button" class="btn btn-secondary btn-sm" onClick={() => handleClearPrecustomer(item)}>
                                  CLEAR PRECUSTOMER
                                </button>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  ))
                ) : (
                  "No customers-in-progress data..."
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default InProgressCustomers;
